import * as actions from './actions';
import * as reducers from './reducers';
import sagas from './sagas';
import * as amc from './ApplicationMenuContainer';

export const ApplicationMenuContainer = amc;

export default {
	actions,
	reducers,
	sagas
};
